import {Link} from 'react-router-dom'
import {PATH_WEB_FORMS} from '../../../../../app/routing/paths'
import {Download, FormatDateToCA, TruncateText} from '../../../../../app/features'
import {Dropdown4} from '../../../content/dropdown/Dropdown4'
import {AddToContacts} from '../../../modals/AddToContacts'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../../helpers'
import {UpdateNoteWebForm} from '../../../modals/UpdateNote.web-form'
import {UpdateStatusWebForm} from '../../../modals/UpdateStatus.web-form'
import React, {FC} from 'react'
import {WebFormsDataTable, WebFormStatus} from '../../../../../app/@types'
import {InitialValuesAddToContactsInterface} from '../../../modals/types'
import {useForms} from '../../../../../app/@contexts/pages/web-forms/FormsProvider'

type Props = {
    item: WebFormsDataTable
    matchedStatus: WebFormStatus | undefined
    index: number
    formData: InitialValuesAddToContactsInterface
}

const EXPORT_TO_PDF = process.env.REACT_APP_EXPORT_TO_PDF || 'data-form-pdf'

const Row: FC<Props> = ({item, matchedStatus, index, formData}) => {

    const {triggerReload} = useForms()


    const {
        id,
        firstName,
        lastName,
        subscriber,
        notes,
        status,
        title,
        date,
        name_categories,
    } = item

    return (
        <tr>
            <td>{FormatDateToCA(date)}</td>
            <td>
                <Link to={`${PATH_WEB_FORMS.form}/${id}`}
                      className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                >{TruncateText(title, 10)}</Link>
            </td>
            <td>
                <Link to={`${PATH_WEB_FORMS.form}/${id}`}
                      className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                >{TruncateText(firstName, 10)}</Link>
            </td>
            <td>
                <Link to={`${PATH_WEB_FORMS.form}/${id}`}
                      className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                >{TruncateText(lastName, 10)}</Link>
            </td>
            <td>
                {matchedStatus
                    ? <span className={`badge badge-light-${matchedStatus.bg} fs-7 fw-bold`}
                            id={`status_${id}`}>{matchedStatus.name}</span>
                    : <span className="badge badge-light-secondary fs-7 fw-bold">Status Unknown</span>}
            </td>
            <td>
                <span
                    className="badge bg-light text-gray-700 px-3 py-2">{name_categories}</span>
            </td>
            <td>
                <Dropdown4 id={`${id}`} index={index} />
            </td>
            <td className="text-center">
                <div className="d-flex justify-content-end flex-shrink-0">
                    {
                        !subscriber && <AddToContacts index={id}
                                                      initialValues={formData}
                                                      triggerReload={triggerReload}
                                                      textIcon={false}
                      />
                    }
                    <Whisper placement="top" controlId="control-id-hover" trigger="hover"
                             speaker={<Tooltip>Aperçu</Tooltip>}>
                        <Link to={`${PATH_WEB_FORMS.form}/${id}`}
                              className="btn btn-sm btn-icon btn-active-light-success"
                        >
                            <KTSVG path={`/media/icons/duotune/layouts/lay005.svg`}
                                   className="svg-icon-3 svg-icon-success" />
                        </Link>
                    </Whisper>
                    <UpdateNoteWebForm id={`${id}`}
                                       notes={notes}
                                       textIcon={false}
                                       size={"lg"}
                    />
                    <UpdateStatusWebForm id={`${id}`}
                                         status={status}
                                         textIcon={false}
                                         size={'md'}
                    />

                    <Whisper placement="top" controlId="control-id-hover" trigger="hover"
                             speaker={<Tooltip>Export</Tooltip>}>
                        <button type="button"
                                className="btn btn-sm btn-icon btn-active-light-danger"
                                onClick={() => Download({
                                    api: EXPORT_TO_PDF,
                                    id: `${id}`,
                                    fileName: title,
                                    fileExtension: 'pdf',
                                })}
                        >
                            <i className="bi bi-file-earmark-pdf-fill fs-4 text-danger" />
                        </button>
                    </Whisper>

                </div>
            </td>
        </tr>
    )
}

export {Row}